module.exports = __webpack_public_path__ + "img/404.521da553.png";